import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

import { AddressVerificationAnalytics } from './AddressVerification.analytics';
import { PersonalVerificationAnalytics } from './PersonalVerification.analytics';
import { SubmitRequestAnalytics } from './SubmitRequest.analytics';

type TEntityType = 'decoder' | 'router';

interface IAddProductSuccessParams {
    type: TEntityType,
    title: string,
    period: number,
    cost?: number,
}

interface IAddProductParams {
    type: TEntityType,
    title: string,
}

export class ConstructorAnalytics extends BaseAnalytics {
    personalVerification: PersonalVerificationAnalytics;
    addressVerification: AddressVerificationAnalytics;
    submitRequest: SubmitRequestAnalytics;

    constructor(category = 'constructor') {
        super();
        this.category = category;
        this.personalVerification = new PersonalVerificationAnalytics(this.category);
        this.addressVerification = new AddressVerificationAnalytics(this.category);
        this.submitRequest = new SubmitRequestAnalytics(this.category);
    }

    moveSpeedSlider() {
        this.send('move_speed_slider');
    }

    clickedHaveSmartTvCheckBox() {
        this.send('click_on_the_i_have_smart_tv_check_box');
    }

    clickedMoveToEquipment() {
        this.send('click_move_to_equipment');
    }

    clickedMoveToSubscription() {
        this.send('click_move_to_subscription');
    }

    clickedOnlineCinemaCheckBox(label: string) {
        this.send('click_on_the_online_cinema_check_box', label);
    }

    clickedTvChannelCheckBox(label: string) {
        this.send('click_on_the_tv_channel_check_box', label);
    }

    clickedSubscriptionCheckBox(title: string) {
        this.send('click_on_the_subscription_check_box', title);
    }

    clickedAntivirusCheckBox(title: string) {
        this.send('click_on_the_antivirus_check_box', title);
    }

    addProductSuccess({ type, title, period, cost }: IAddProductSuccessParams) {
        const label = `type:${type}|name:${title}|price:${cost}|dur:${period}|`;
        this.send('add_product_success', label);
    }

    clickedAddProduct({ type, title }: IAddProductParams) {
        this.send('click_add_product', `type:${type}|name:${title}|`);
    }

    clickedMoveToFullbuyForm() {
        this.send('click_move_to_fullbuy_form');
    }

    clickedOpenConnectionCostPopup() {
        this.send('connection_cost_popup', 'view_popup');
    }
}


export const constructorAnalytics = new ConstructorAnalytics();
